var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-detection-package-new',{staticClass:"pt-detection-package-new__withData"})}
var staticRenderFns = []

export { render, staticRenderFns }